export default "__VITE_ASSET__cf4609b1__"